import React from 'react';
import Colors from '@data/enums/Color.enum';

export function mustard({ fill = Colors.TEXT_DEFAULT }) {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M11.5833 6.86935C11.5833 6.37688 11.75 6.02513 11.8333 5.81407H12.3333L13.0833 4.05528H13.75V3H6.25V4.05528H6.91667L7.66667 5.81407H8.16667C8.33333 6.02513 8.41667 6.37688 8.41667 6.86935C8.41667 7.78392 5 11.2312 5 13.9749V15.3819C5 16.3668 7.25 17 10 17C12.75 17 15 16.3668 15 15.3819V13.9749C15 11.2312 11.5833 7.78392 11.5833 6.86935ZM10 12.1457C9.55797 12.1457 9.13405 11.9975 8.82149 11.7336C8.50893 11.4697 8.33333 11.1119 8.33333 10.7387C8.33333 10.3655 8.50893 10.0076 8.82149 9.74377C9.13405 9.4799 9.55797 9.33166 10 9.33166C10.442 9.33166 10.866 9.4799 11.1785 9.74377C11.4911 10.0076 11.6667 10.3655 11.6667 10.7387C11.6667 11.1119 11.4911 11.4697 11.1785 11.7336C10.866 11.9975 10.442 12.1457 10 12.1457Z'
        fill={fill} />
    </svg>
  );
}
